import Configuration from '@/src/components/Configuration/Configuration';
import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { get, last } from 'lodash';
import React from 'react';
import { useParams } from 'react-router-dom';
import {
  Form,
  OriCheckbox,
  RadioGroup,
  RadioItem,
  TextArea,
} from 'src/components/Antd';
import InputWithTags from 'src/components/InputWithTags';
import { Uploader, useSingleImageEffect } from 'src/components/Upload';
import { useI18n } from 'src/hooks/useRouterChange';
import Section from 'src/pages/SalesCannelVersion/Components/SectionContainer';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import { RegistrationErrorContext } from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelRegistration/ErrorContext';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import css from './css.module.less';

const Item = Form.Item;
enum EVisiblePolicy {
  NOT_ALLOW_NEW_USER_REQUEST = 'NOT_ALLOW_NEW_USER_REQUEST',
  ALLOW_USER_ACCESS_BASED_ON_EMAIL = 'ALLOW_USER_ACCESS_BASED_ON_EMAIL',
  ALLOW_USER_ACCESS_BASED_ON_MOBILE = 'ALLOW_USER_ACCESS_BASED_ON_MOBILE',
  ALLOW_USER_ACCESS_BASED_ON_EMAIL_MOBILE = 'ALLOW_USER_ACCESS_BASED_ON_EMAIL_MOBILE',
}

const PublicAccess = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { uuid: salesChannelUuid }: any = useParams();
  const { landingImageError, setLandingImageError } = React.useContext(
    RegistrationErrorContext,
  );
  const { data, onChange, setHasModified, disableEdit, form } = props;
  const _modified = () => {
    setHasModified(true);
  };
  // const enableOnlyVisibleAfterLogin = get(data, 'enableOnlyVisibleAfterLogin');
  // const visibilityPolicy = get(data, 'visibilityPolicy');
  const backgroundImage = get(data, 'backgroundImage');
  //const enableLoginRemarks = get(data, 'enableLoginRemarks');
  //const loginRemarks = get(data, 'loginRemarks');

  const [fileList, setFileList] = React.useState(
    backgroundImage ? [backgroundImage] : [],
  );
  useSingleImageEffect(backgroundImage, fileList, setFileList);

  const onTypeChange = (e) => {
    _modified();
    // const key = e.target.value;
    // if (key && onChange) {
    //   const state = {
    //     visibilityPolicy: key,
    //   };
    //   onChange({ ...(data || {}), ...state });
    // }
  };

  const handleOnEnabledChange = (e) => {
    _modified();
    if (e.target.checked) {
      form.setFieldsValue({
        allowAccessByCode: false,
      });
    }
    // const checked = e.target.checked;
    // if (onChange) {
    //   onChange({
    //     ...(data || {}),
    //     enableOnlyVisibleAfterLogin: checked,
    //   });
    // }
  };

  const handleOnAccessEnabledChange = (e) => {
    _modified();
    //console.log('e', e.target.checked);
    if (e.target.checked) {
      form.setFieldsValue({
        enableOnlyVisibleAfterLogin: false,
      });
    }
    // const checked = e.target.checked;
    // if (onChange) {
    //   onChange({
    //     ...(data || {}),
    //     enableOnlyVisibleAfterLogin: checked,
    //   });
    // }
  };

  const handleOnRemarksOpenChange = (e) => {
    _modified();
    // const enableLoginRemarks = e.target.checked;
    // if (onChange) onChange({ ...(data || {}), enableLoginRemarks });
  };

  const handleOnRemarksChange = () => {
    _modified();

    //  if (onChange) onChange({ ...(data || {}), loginRemarks });
  };

  const handleModified = () => {
    _modified();
  };

  return (
    <SectionWrapper
      title={getI18n('salesChannelRegistration.index.publicAccess')}
      containerClassName={css.containerClassName}>
      <Section bottomBorder>
        <Item
          shouldUpdate={(prevValues, curValues) => {
            const pEnable = !!get(prevValues, 'enableOnlyVisibleAfterLogin');
            const cEnable = !!get(curValues, 'enableOnlyVisibleAfterLogin');
            return pEnable !== cEnable;
          }}>
          {({ getFieldValue }: any) => {
            const enableOnlyVisibleAfterLogin = getFieldValue(
              'enableOnlyVisibleAfterLogin',
            );
            return (
              <Item name='enableOnlyVisibleAfterLogin' valuePropName='checked'>
                <OriCheckbox
                  disabled={disableEdit}
                  // checked={enableOnlyVisibleAfterLogin}
                  className={enableOnlyVisibleAfterLogin ? '' : css.checkout}
                  onChange={handleOnEnabledChange}>
                  {getI18n(
                    'salesChannelRegistration.index.onlyvisibleafterlogin',
                  )}
                </OriCheckbox>
              </Item>
            );
          }}
        </Item>
        <Item
          shouldUpdate={(prevValues, curValues) => {
            const pEnable = !!get(prevValues, 'enableOnlyVisibleAfterLogin');
            const cEnable = !!get(curValues, 'enableOnlyVisibleAfterLogin');
            return pEnable !== cEnable;
          }}>
          {({ getFieldValue }: any) => {
            const enableOnlyVisibleAfterLogin = getFieldValue(
              'enableOnlyVisibleAfterLogin',
            );

            return enableOnlyVisibleAfterLogin ? (
              <Item name='visibilityPolicy'>
                <RadioGroup
                  disabled={disableEdit}
                  onChange={onTypeChange}
                  // value={visibilityPolicy}
                  className={css.radioGroup}>
                  <RadioItem
                    className={css.radio}
                    value={EVisiblePolicy.NOT_ALLOW_NEW_USER_REQUEST}>
                    {getI18n('salesChannelRegistration.index.dontallownewuser')}
                  </RadioItem>
                  <RadioItem
                    className={css.radio}
                    value={
                      EVisiblePolicy.ALLOW_USER_ACCESS_BASED_ON_EMAIL_MOBILE
                    }>
                    {getI18n(
                      'salesChannelRegistration.index.allowemailormobile',
                    )}
                  </RadioItem>
                  <RadioItem
                    className={css.radio}
                    value={EVisiblePolicy.ALLOW_USER_ACCESS_BASED_ON_EMAIL}>
                    {getI18n('salesChannelRegistration.index.allowemail')}
                  </RadioItem>
                  <RadioItem
                    value={EVisiblePolicy.ALLOW_USER_ACCESS_BASED_ON_MOBILE}>
                    {getI18n('salesChannelRegistration.index.allowmobile')}
                  </RadioItem>
                </RadioGroup>
              </Item>
            ) : null;
          }}
        </Item>
        <Item
          shouldUpdate={(prevValues, curValues) => {
            // const pEnable = !!get(prevValues, 'enableOnlyVisibleAfterLogin');
            // const cEnable = !!get(curValues, 'enableOnlyVisibleAfterLogin');

            const pEnableAccess = !!get(prevValues, 'allowAccessByCode');
            const cEnableAccess = !!get(curValues, 'allowAccessByCode'); //pEnable !== cEnable ||

            return pEnableAccess !== cEnableAccess;
          }}>
          {({ getFieldValue, setFieldsValue }: any) => {
            //const allowAccessByCode = getFieldValue('allowAccessByCode');
            return (
              <Item name='allowAccessByCode' valuePropName='checked'>
                <OriCheckbox
                  disabled={disableEdit}
                  // checked={enableOnlyVisibleAfterLogin}
                  className={css.checkout}
                  onChange={handleOnAccessEnabledChange}>
                  {getI18n(
                    'salesChannelRegistration.index.allowsimpleaccesscode',
                  )}
                </OriCheckbox>
              </Item>
            );
          }}
        </Item>
        <Item
          shouldUpdate={(prevValues, curValues) => {
            // const pEnable = !!get(prevValues, 'enableOnlyVisibleAfterLogin');
            // const cEnable = !!get(curValues, 'enableOnlyVisibleAfterLogin');

            const pEnableAccess = !!get(prevValues, 'allowAccessByCode');
            const cEnableAccess = !!get(curValues, 'allowAccessByCode'); //pEnable !== cEnable ||

            return pEnableAccess !== cEnableAccess;
          }}>
          {({ getFieldValue, setFieldsValue }: any) => {
            const allowAccessByCode = getFieldValue('allowAccessByCode');
            return allowAccessByCode ? (
              <Item
                name='accessCodes'
                rules={[
                  {
                    required: true,
                    validator: async (x, value) => {
                      // const { value1, value2 } = value;
                      if ((value || []).length < 1) {
                        return Promise.reject(
                          new Error(
                            getI18n(
                              'salesChannelRegistration.index.pleasefillaccesscodes',
                            ),
                          ),
                        );
                      }
                    },
                  },
                ]}>
                <InputWithTags
                  title={getI18n('salesChannelRegistration.index.promoCode')}
                  subtitle={getI18n(
                    'salesChannelRegistration.index.promoCodeSubTitle',
                  )}
                  placeholder={getI18n(
                    'salesChannelRegistration.index.addnewPromoCode',
                  )}
                  duplicateError={getI18n(
                    'salesChannelRegistration.index.addnewduplicateError',
                  )}
                  onChange={handleModified}
                />
              </Item>
            ) : null;
          }}
        </Item>
      </Section>
      <Item
        shouldUpdate={(prevValues, curValues) => {
          const pEnable = !!get(prevValues, 'enableOnlyVisibleAfterLogin');
          const cEnable = !!get(curValues, 'enableOnlyVisibleAfterLogin');
          const pAccessEnable = !!get(prevValues, 'allowAccessByCode');
          const cAccessEnable = !!get(curValues, 'allowAccessByCode');
          return pEnable !== cEnable || pAccessEnable !== cAccessEnable;
        }}>
        {({ getFieldValue }: any) => {
          const enableOnlyVisibleAfterLogin = getFieldValue(
            'enableOnlyVisibleAfterLogin',
          );
          const allowAccessByCode = getFieldValue('allowAccessByCode');
          return enableOnlyVisibleAfterLogin || allowAccessByCode ? (
            <React.Fragment>
              <Section bottomBorder>
                <ItemWrapper
                  id='SalesChannelRegistrationLandingImage'
                  error={landingImageError}
                  errorText={getI18n(
                    'salesChannelRegistration.index.landingPageBackgroundImageerror',
                  )}
                  title={`${getI18n(
                    'salesChannelRegistration.index.landingPageBackgroundImage',
                  )}*`}
                  rightSubTitle={getI18n(
                    'salesChannelRegistration.index.landingPageBackgroundImagesubtitle',
                  )}>
                  <Uploader
                    height={180}
                    disabled={disableEdit}
                    multiple={false}
                    fileList={fileList}
                    onChange={(imgArr = []) => {
                      setLandingImageError(false);
                      setFileList(imgArr);
                      if (onChange) {
                        const _l = last(imgArr);
                        handleModified();
                        onChange({
                          ...(data || {}),
                          backgroundImage: _l,
                        });
                      }
                    }}
                  />
                </ItemWrapper>
              </Section>
              <Section>
                <ItemWrapper
                  title={
                    <Item name='enableLoginRemarks' valuePropName='checked'>
                      <OriCheckbox onChange={handleOnRemarksOpenChange}>
                        {getI18n('salesChannelRegistration.index.loginRemarks')}
                      </OriCheckbox>
                    </Item>
                  }
                  rightPart={
                    <Item
                      shouldUpdate={(prevValues, curValues) => {
                        const pLoginRemarks = get(prevValues, 'loginRemarks');
                        const cLoginRemarks = get(curValues, 'loginRemarks');
                        const pEnable = !!get(prevValues, 'enableLoginRemarks');
                        const cEnable = !!get(curValues, 'enableLoginRemarks');
                        return (
                          pEnable !== cEnable || pLoginRemarks !== cLoginRemarks
                        );
                      }}>
                      {({ getFieldValue }: any) => {
                        const loginRemarks =
                          getFieldValue('loginRemarks') || '';
                        const enable =
                          getFieldValue('enableLoginRemarks') || '';

                        return enable ? (
                          <CountWords
                            count={(loginRemarks || '').length}
                            allCount={500}
                          />
                        ) : null;
                      }}
                    </Item>
                  }>
                  <Item
                    shouldUpdate={(prevValues, curValues) => {
                      const pLoginRemarks = get(prevValues, 'loginRemarks');
                      const cLoginRemarks = get(curValues, 'loginRemarks');
                      const pEnable = !!get(prevValues, 'enableLoginRemarks');
                      const cEnable = !!get(curValues, 'enableLoginRemarks');
                      return (
                        pEnable !== cEnable || pLoginRemarks !== cLoginRemarks
                      );
                    }}>
                    {({ getFieldValue }: any) => {
                      //const loginRemarks = getFieldValue('loginRemarks') || '';
                      const enable = getFieldValue('enableLoginRemarks') || '';
                      return enable ? (
                        <React.Fragment>
                          <Item
                            name='loginRemarks'
                            rules={[
                              {
                                required: true,
                                message: replaceI18nVariables(
                                  getI18n('general.fieldisrequired'),
                                  getI18n(
                                    'salesChannelRegistration.index.loginRemarks',
                                  ),
                                ),
                              },
                            ]}>
                            <TextArea
                              // value={loginRemarks}
                              disabled={disableEdit}
                              onChange={handleOnRemarksChange}
                              maxLength={500}
                              autoSize={{ minRows: 3, maxRows: 5 }}
                            />
                          </Item>
                          <div className={css.configContainer}>
                            <Configuration
                              configStart={getI18n(
                                'salesChannelRegistration.index.languageconfigstart',
                              )}
                              configLink={getI18n(
                                'salesChannelRegistration.index.languageconfiglink',
                              )}
                              linkTo={`/salesChannel/setting/language/${salesChannelUuid}`}
                              configEnd={getI18n(
                                'salesChannelRegistration.index.languageconfigend',
                              )}
                            />
                          </div>
                        </React.Fragment>
                      ) : null;
                    }}
                  </Item>
                </ItemWrapper>
              </Section>
            </React.Fragment>
          ) : null;
        }}
      </Item>
    </SectionWrapper>
  );
};

export default PublicAccess;
